import theme from 'shared/theme';
import styled, { css } from 'styled-components';
// import ReactImage from 'react-image';
import { zIndex } from '../globals';
import { Link } from 'react-router-dom';
import { ProfileHeaderAction } from '../profile/style';
import { MEDIA_BREAK } from 'src/components/layout';

export const Container = styled.div`
  position: relative;
  display: inline-block;
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  border-radius: 100%;
  border: none;
  background-color: ${theme.bg.default};
  /* margin-bottom: 5px; */

  ${props =>
    props.mobilesize &&
    css`
      @media (max-width: ${MEDIA_BREAK}px) {
        width: ${props => `${props.mobilesize}px`};
        height: ${props => `${props.mobilesize}px`};
      }
    `};
`;

export const AvatarLink = styled(Link)``;

export const CoverAction = styled(ProfileHeaderAction)`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: ${zIndex.tooltip + 1};
`;

export const Img = styled.image`
  display: inline-block;
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  border-radius: 100%;
  object-fit: cover;
  background-color: ${theme.bg.default};

  ${props =>
    props.mobilesize &&
    css`
      @media (max-width: ${MEDIA_BREAK}px) {
        width: ${props => `${props.mobilesize}px`};
        height: ${props => `${props.mobilesize}px`};
      }
    `};
`;

export const FallbackImg = styled.img`
  display: inline-block;
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  border-radius: 100%;
  object-fit: cover;
  background-color: ${theme.bg.wash};

  ${props =>
    props.mobilesize &&
    css`
      @media (max-width: ${MEDIA_BREAK}px) {
        width: ${props => `${props.mobilesize}px`};
        height: ${props => `${props.mobilesize}px`};
      }
    `};
`;

export const LoadingImg = styled.div`
  display: inline-block;
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  border-radius: ${props =>
    props.type === 'community' ? `${props.size / 8}px` : '100%'};
  background: ${theme.bg.wash};

  ${props =>
    props.mobilesize &&
    css`
      @media (max-width: ${MEDIA_BREAK}px) {
        width: ${props => `${props.mobilesize}px`};
        height: ${props => `${props.mobilesize}px`};
      }
    `};
`;

export const OnlineIndicator = styled.span`
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid
    ${props =>
      props.onlineBorderColor
        ? props.onlineBorderColor(props.theme)
        : props.theme.text.reverse};
  background: ${theme.success.alt};
  border-radius: 8px;
  bottom: 0;
  right: 0;
  z-index: 1;
`;

export const IdentityIndicator = styled.img`
  width: 20px;
  height: 20px;
  margin-left: -20px;
`;

export const DefaultAvatar = styled.div`
  text-decoration: none;
  color: white;
  background-color: ${props => {
    switch (props.colorIndex) {
      case 0:
        return theme.avatar.avatar0;
      case 1:
        return theme.avatar.avatar1;
      case 2:
        return theme.avatar.avatar2;
      case 3:
        return theme.avatar.avatar3;
      case 4:
        return theme.avatar.avatar4;
      case 5:
        return theme.avatar.avatar5;
      case 6:
        return theme.avatar.avatar6;
      case 7:
        return theme.avatar.avatar7;
      case 8:
        return theme.avatar.avatar8;
      case 9:
        return theme.avatar.avatar9;
      case 10:
        return theme.avatar.avatar10;
      case 11:
        return theme.avatar.avatar11;
      case 12:
        return theme.avatar.avatar12;
      case 13:
        return theme.avatar.avatar13;
    }
  }};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  font-size: ${props => (props.fontSize ? `${props.fontSize}px` : '14px')};
`;

export const AvatarWrapper = styled.div`
  position: relative;
  padding: 0;
  /* margin: 0 1.6rem 0 0; */
  width: ${props => (props.size ? `${props.size}px` : '32px')};
  height: ${props => (props.size ? `${props.size}px` : '32px')};
  display: flex;
`;

export const SubAvatar = styled.div`
  position: absolute;
  left: 68%;
  bottom: -25%;
`;
